import {
    SET_USER_INFO,
    SHOW_USER_LOADER,
    HIDE_USER_LOADER
} from "../actions/user"


const initialState = {
    userInfo: {},
    showUserLoader: true,
};

export default function getUser(state = initialState, action){

    switch ( action.type ) {

        case SET_USER_INFO:
            return {
                ...state,
                userInfo: action.userInfo,
                showUserLoader: false
            }
            break;

        case SHOW_USER_LOADER:
            return {
                ...state,
                showUserLoader: true
            }
            break;

        case HIDE_USER_LOADER:
            return {
                ...state,
                showUserLoader: false
            };

        default:
            return state;
    }

}